<style lang="scss" src='./App.scss'></style>
<template src="./App.html"></template>

<script type="text/javascript">
  import { Loader } from 'google-maps';
  import { isEmpty } from 'lodash';
  import StoreHeader from '@/components/header/Header'
  import StoreFooter from '@/components/footer/Footer'
  import StoreCartLateral from '@/components/cartLateral/CartLateral'
  import WhatsAppButton from '@/components/whatsappButton/WhatsAppButton'
import { mapActions } from 'vuex';
  
  const mapLoader = new Loader(process.env.VUE_APP_KEY_GOOGLE_MAP, {
    libraries: ['places']
  });

  export default {
    name: 'App',
    components: {
      StoreHeader,
      StoreFooter,
      StoreCartLateral,
      WhatsAppButton,
    },
    data() {
      return {
        tempBgIndex: 0,
      };
    },
    methods: {
      ...mapActions('CartStore', ['fnApiGetCart']),

      giveChars(str) {
        return str.slice(0, 3);
      },
      signed() {
        if (!isEmpty(this.user)) {
          this.$store.state.logged = true;
        }
      },

      async signOut() {
        this.F_signout();
      },

    },

    beforeMount() {
      this.consts.Google.MAP_LOADER = mapLoader;
      this.signed();
      this.fnApiGetCart();
    },

    mounted() {
      
    },

    beforeUpdate() {
      if (!isEmpty(this.user)) {
        this.$store.state.logged = true;
      }
      this.signed();
    },

    computed: {
      user() {
        return this.$store.state.user;
      },
    },

    watch: {

    },
  };

</script>
